/**
 * RelatedPosts - Display related blog posts
 */

import type { BlogPost } from "../../lib/blog";
import { BlogCard } from "./BlogCard";

interface RelatedPostsProps {
  posts: BlogPost[];
}

export function RelatedPosts({ posts }: RelatedPostsProps) {
  if (posts.length === 0) return null;

  return (
    <div>
      <h2 className="font-display font-bold text-display-sm text-neutral-900 mb-8 text-center">
        Related Articles
      </h2>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
        {posts.map((post) => (
          <BlogCard key={`${post.category}/${post.slug}`} post={post} />
        ))}
      </div>
    </div>
  );
}
